import React from "react";
import PropTypes from "prop-types";
import NewOrderLink from "./link";
import NewOrderFacilityModal from "./FacilityModal";
import PartnerModal from "./PartnerModal";
import NEDModal from "./NEDModal";

// Configuration object mapping contract types to their components
const CONTRACT_TYPE_CONFIG = {
  Community: {
    component: NewOrderLink,
    requiresBackground: false,
    requiresCurrentUser: false
  },
  Hospital: {
    component: NewOrderFacilityModal,
    requiresBackground: true,
    requiresCurrentUser: true
  },
  // Default for other contract types
  default: {
    component: PartnerModal,
    requiresBackground: true,
    requiresCurrentUser: true
  }
};

const ContractRenderer = ({ 
  contract, 
  buttonText, 
  onClose, 
  currentUser,
  cssClass, 
  background = true
}) => {
  // Handle NED contracts first (they have priority)
  if (contract.nedSyncEnabled) {
    return (
      <NEDModal
        contract={contract}
        closeParentModal={onClose}
        cssClass={cssClass}
        linkText={buttonText}
        currentUser={currentUser}
        background={background}
      />
    );
  }

  // Get configuration for contract type
  const config = CONTRACT_TYPE_CONFIG[contract.contractType] || CONTRACT_TYPE_CONFIG.default;
  const Component = config.component;

  // Prepare props based on component requirements
  const componentProps = {
    contract,
    closeParentModal: onClose,
    cssClass,
    linkText: buttonText,
    background: config.requiresBackground ? background : false
  };

  // Add currentUser if required by the component
  if (config.requiresCurrentUser) {
    componentProps.currentUser = currentUser;
  }

  // Special handling for NewOrderLink which uses closeModal instead of closeParentModal
  if (Component === NewOrderLink) {
    componentProps.closeModal = onClose;
    delete componentProps.closeParentModal;
  }

  return <Component {...componentProps} />;
};

ContractRenderer.propTypes = {
  contract: PropTypes.object.isRequired,
  buttonText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  background: PropTypes.bool,
  cssClass: PropTypes.string
};

export default ContractRenderer;
